var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_c('p',{staticClass:"welcome"},[_vm._v("欢迎来到字景数科物联网系统平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }